import { GridOptions, RowHeightParams } from 'ag-grid-community'
import { isNil } from 'lodash'
import { gridOptionsBase } from 'view/components/datagrid'
import { NestedLegItemWithIndex } from './model'

export const preAssignmentSubGridOptions: GridOptions<NestedLegItemWithIndex> = {
  ...gridOptionsBase,
  getRowId: ({ data }) => `${data.index}`
}

export const getDynamicDetailRowHeight = <T>(rowsLengthGetter: (data: RowHeightParams<T>['data']) => number | null | undefined) => (
  params: RowHeightParams<T>
) => {
  const isDetailRow = params.node.detail
  if (!isDetailRow) return undefined

  const ROW_HEIGHT = 40
  const HEADER_HEIGHT = 40
  const PADDING_VERTICAL = 20

  const rowsLength = rowsLengthGetter(params.data)
  const detailPanelHeight = rowsLength ? rowsLength * ROW_HEIGHT + HEADER_HEIGHT + PADDING_VERTICAL + PADDING_VERTICAL : null

  if (isNil(detailPanelHeight)) return undefined

  return detailPanelHeight < 1000 ? detailPanelHeight : 1000
}
